import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { ConfirmService }           from '../messages/confirm/confirm.service';
import { SecretKeysComponent }      from '../shared/components/secret-keys/secret-keys.component';
import { WsApiKeysModel }           from './typings/ws-api.keys';
import { WsApiSettingsModel }       from './typings/ws-api.settings.model';

@Injectable({
  providedIn: 'root'
})
export class WsApiService {
  public title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.WORKSHOP_API');

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  activate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.title
      }))
      .then(() => this.apiService.post('/workshop_api'));
  }

  deactivate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
        name: this.title
      }))
      .then(() => this.apiService.get('/workshop_api/deactivate'));
  }

  generateApiKey () : Promise<any> {
    return this.apiService.get('/workshop_api/generate_new_credentials')
      .then(( keys : WsApiKeysModel ) => {
        const modal =  this.modalService.open(SecretKeysComponent, {
          size: 'lg'
        });

        modal.componentInstance.keys = {
            apiKey   : keys.workshop_api_key,
            companyId: keys.masked_company_id,
            secretKey: keys.workshop_api_secret
          };

        return modal.result;
      });
  }

  getIntegrations () : Promise<CompanyIntegrationsModel> {
    return this.apiService.get('/company_integrations');
  }

  getSettings () : Promise<WsApiSettingsModel> {
    return this.apiService.get('/workshop_api');
  }
}
